import { render } from "./CardSistemaIss.vue?vue&type=template&id=620aca46"
import script from "./CardSistemaIss.vue?vue&type=script&lang=js"
export * from "./CardSistemaIss.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__